import { FC, ImgHTMLAttributes } from "react";

type ImgFullProps = ImgHTMLAttributes<HTMLImageElement>;

const ImgFull: FC<ImgFullProps> = ({ ...props }) => {
  return (
    <img {...props} className="h-full w-full object-cover object-center" />
  );
};

export default ImgFull;
